import {TranslationObject} from '@colonist/i18n'
import {UIGameManager} from '../UIGameManager'
import {GameFont} from '../../GameFont'
import {UIGameFloatingVictoryPointsView} from './UIGameFloatingVictoryPointsView'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'

export class UIGameHowToWinFloatingVPView extends UIGameFloatingVictoryPointsView {
    constructor(uiGameManager: UIGameManager) {
        const canvas = uiGameManager.canvasController
        const isUserOnMobileAppOrWeb = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI && !UIUtilsEjsVariables.isUserOnTabletApp

        const w = canvas.itemSize * (isUserOnMobileAppOrWeb ? 10 : 7)
        const h = canvas.itemSize * (isUserOnMobileAppOrWeb ? 1 : 0.6)

        const x = uiGameManager.mapController.mapView.left + (uiGameManager.mapController.mapView.worldScreenWidth - w) / 2
        const y = uiGameManager.mapController.mapView.top + uiGameManager.mapController.mapView.hexagonHeight
        const container = uiGameManager.mapController.mapView
        const text: TranslationObject = {key: 'strings:game.howToWin', options: {vpCount: uiGameManager.gameController.gameSettings.victoryPointsToWin}}
        super(uiGameManager, x, y, w, h, container, text, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ribbon_long))

        const distanceY = uiGameManager.mapController.mapView.hexagonHeight / 2
        const velocityY = 0.4
        const fadeSpeed = 0.06
        this.drawText(text, GameFont.Size.L)
        this.drawTrophy()
        this.setVerticalAnimation(distanceY, velocityY, fadeSpeed, true, 3500)
        this.zIndex = uiGameManager.mapController.mapView.layers.informationPopups
    }
}
